var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-page-container"},[_c('div',{staticClass:"home-page-column"},[_c('PageView',{attrs:{"id":_vm.generalSettings['home_page'],"no-title":true}}),_c('PostsView',{attrs:{"id":_vm.generalSettings['home_page_category_1'],"no-title":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }